import SalePage from "@/pages/sale/sale-page";
import { route } from "../utils";
import { RouteType } from "../types";

// Define routes with semantic names - single source of truth
export const saleRoutes: Record<string, RouteType> = {
  sale: route("/sale", SalePage),
  // live: route("/sale/live", SalePage),
  // post: route("/sale/post", SalePage),
  // inbox: route("/sale/inbox", SalePage),
};
